// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__8SVDj","popup":"tooltip_popup__B-tac typography_text--xs__Ts3SD","popupMultiline":"tooltip_popupMultiline__+rP1G","icon":"tooltip_icon__C0fQd"};